import { getPlatform, Platform } from "../platform/platform";

type PlatformText = {
    telegram: string;
    max: string;
};

const TEXT: Record<string, PlatformText> = {
    channelIn: {
        telegram: "телеграм-канале",
        max: "канале в Max",
    },
    channelOfIn: {
        telegram: "телеграм-канала",
        max: "канала в Max",
    },
    channelName: {
        telegram: "телеграм-канал",
        max: "канал в Max",
    },
};

export type PlatformTextKey = keyof typeof TEXT;

export const getPlatformText = (key: PlatformTextKey): string => {
    const entry = TEXT[key];
    return getPlatform() === Platform.Max ? entry.max : entry.telegram;
};

